export default [
  // misc
  "ZENNY",
  "CHIPS",
  "CYBER",
  "PANEL",
  "COLOR",
  "POINT",
  "GAUGE",
  "VIRUS",
  "DRILL",
  "SNEAK",
  "HPMEM",
  "BREAK",
  // NCP
  "SHOES",
  "HUMOR",
  "TANGO",
  "ARMOR",
  "BLOCK",
  // humans
  "CHAUD",
  "BARYL",
  // navis
  "GLIDE",
  "PROTO",
  // "NUMBR", // NumbrMan Chips + NumberMan
  "MAGIC",
  "SKULL",
  "SHARK",
  "PHARO",
  // "SHADO",
  // "MAGNT",
  // "NAPLM",
  "METAL",
  "JAPAN",
  // "BUBBL",
  "SPARK",
  "VIDEO",
  "SHADE",
  "COSMO",
  "MEDDY",
  "CHAOS",
  "SPOUT",
  "BLAST",
  "JUDGE",
  "ERASE",
  "TENGU",
  "BEAST",
  "CACHE",
  "KENDO",
  "LASER",
  "QUICK",
  "STONE",
  // chips
  "STEAL",
  "CLOUD",
  "INVIS",
  "POPUP",
  "SWORD",
  "BLADE",
  "PUNCH",
  "LANCE",
  "GUARD",
  "RECOV",
  "ARROW",
  "SPICE",
  "SHAKE",
  "PANIC",
  "BATCH",
  "SNAKE",
  "QUAKE",
  "DELTA",
  "STAGE",
  // viruses
  "BILLY",
  "FISHY",
  "RATTY",
  "PUFFY",
  "JELLY",
  "BUNNY",
  "POWIE",
  "PENGI",
  "VINEY",
  "ALPHA",
  "TOTEM",
  "TWINS",
  "KILBY",
  "WALLA",
  "BATTY",
  "HANDI",
  "ZOMON",
  "BRUTE",
  "HEADY",
  "GOLEM",
];
